module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.chart,
      "thousands": ",",
      "label": _vm.legend,
      "legend": "left"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ba27e61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/charts/SharersBarChart.vue
// module id = 1431
// module chunks = 0